import { useEffect, useState } from 'react';

// Re-render at the opening boundary even when the page has been left open.
export default function useTournamentClock(tours) {
  const [now, setNow] = useState(Date.now);
  const schedule = tours.map((tour) => tour?.registrationOpensAt || '').join('|');
  useEffect(() => {
    const update = () => setNow(Date.now());
    const next = schedule.split('|').map(Date.parse).filter((time) => time > Date.now()).sort((a, b) => a - b)[0];
    const timer = next ? window.setTimeout(update, Math.min(next - Date.now() + 30, 2147483647)) : null;
    document.addEventListener('visibilitychange', update);
    return () => {
      window.clearTimeout(timer);
      document.removeEventListener('visibilitychange', update);
    };
  }, [schedule, now]);
  return now;
}
